var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sidebar",staticClass:"sidebar"},[_c('div',{ref:"editableBox",staticClass:"editable-box",attrs:{"contenteditable":"true"},on:{"focus":_vm.startEditing,"blur":_vm.saveContent,"input":_vm.applyStyling,"compositionstart":function($event){_vm.isComposing = true},"compositionend":_vm.handleCompositionEnd,"keydown":_vm.handleKeydown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }